import { Component, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { BaseSectionComponent } from 'src/app/+grid-application-shared/components/common/base-section.component';
import { RegepProcessStatus } from 'src/app/+regep/entities/enums/regepProcessStatus';
import { RegistrationOfEnergyProducerRegulatoryData } from 'src/app/+regep/entities/regep-regulatory-data';
import { RegepCommentsService } from 'src/app/+regep/services/regep-comments.service';
import { RegepOrderProcessService } from 'src/app/+regep/services/regep-order-process.service';
import { FileEvent } from 'src/app/+shared/models/fileEvent';
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
  selector: 'app-base-regulatory-section',
  template: '',
})
export abstract class BaseRegulatorySectionComponent extends BaseSectionComponent {
  @Input() regulatoryData: RegistrationOfEnergyProducerRegulatoryData;
  @Input() regulatoryForm: NgForm;

  constructor(
    protected commentService: RegepCommentsService,
    protected environmentService: EnvironmentService,
    protected orderProcessService: RegepOrderProcessService
  ) {
    super(environmentService);
  }

  public clearFile(fileEvent: FileEvent): void {
    if (!fileEvent.documentId) {
      return;
    }

    if (!this.regulatoryData.document_ids_for_deletion) {
      this.regulatoryData.document_ids_for_deletion = [];
    }

    this.regulatoryData.document_ids_for_deletion.push(fileEvent.documentId);
    this.regulatoryForm.form.markAsDirty();
  }

  public sectionButtonsVisible(): Observable<boolean> {
    if (this.isModeratorRole()) return of(true);

    return this.orderProcessService.orderProcess$.pipe(map(orderProcess => orderProcess.status != RegepProcessStatus.EngineeringOk));
  }

  protected async saveComment(): Promise<void> {
    if (this.regulatoryData.regulatory_data_sections_state.application_id) {
      return await this.commentService
        .updateRegulatoryDataSectionComment(this.regulatoryData.regulatory_data_sections_state)
        .pipe(first())
        .toPromise();
    }

    this.regulatoryData.regulatory_data_sections_state.application_id = this.applicationId;

    await this.commentService
      .createRegulatoryDataSectionComment(this.regulatoryData.regulatory_data_sections_state)
      .pipe(first())
      .toPromise();
  }
}
